<template>
  <v-app id="keep">
  
    <v-navigation-drawer 
      v-model="drawer"
      v-if="currentUser"
      fixed
      clipped
      class="grey lighten-4"
      app
    >
      <v-list
        dense
        class="grey lighten-4"
      >
        <template v-for="(item, i) in items" >
         <div id="Role" :key="i" v-if="item.role.includes(user.role)" >
          <v-layout
            v-if="item.heading"
            :key="i"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
 
          </v-layout>
          <v-divider
            v-else-if="item.divider"
            :key="i"
            dark
            class="my-3"
          ></v-divider>
          <v-list-tile
           
            v-else
            :key="i"
            :to="item.routerlink"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="grey--text"  >
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
         </div>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar color="blue darken-3" dark app absolute clipped-left v-if="currentUser">
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <span class="hidden-sm-and-down">MYOID&nbsp;<span class="font-weight-light">Loader ({{user.username}})</span></span>
        </v-toolbar-title>
         <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon @click="logout" v-if="currentUser">exit_to_app</v-icon>
      </v-btn>
    

    </v-toolbar>
    <v-content>
      <v-container fluid fill-height class="grey lighten-4">
        <v-layout justify-center align-center>
           <v-flex shrink> 
          </v-flex>

            <router-view></router-view>
          
        </v-layout>

          <div class="mybar">
                <v-snackbar v-model="snack_show" :timeout=3000 color="blue darken-3">
                {{snack_message}}
                <v-btn flat color="grey" @click.native="snack_show = false">Close</v-btn>
              </v-snackbar>
          </div>
      </v-container>
      
    </v-content>
  </v-app>


      
  

</template>

<script>


import { authenticationService } from '@/services';
import { Role } from '@/auth';
import { router } from '@/router';
import store from '@/store'

export default {
    name: 'app',

    data () {
   
        return {
            user: authenticationService.currentUserValue,
            showSccuessAlert: false,
            source: String,
            drawer: false,
            loggedin: false,

            items: [
              { icon: 'lightbulb_outline', text: 'MYOID-Liste', routerlink: 'myoidliste', role: [Role.Observer, Role.Admin, Role.StudienArzt, Role.MFA] },
              { icon: 'lightbulb_outline', text: 'Strain-Messung: Verfügbare MYOIDs', routerlink: 'myoidbyuser', role: [Role.Observer, Role.Admin, Role.StudienArzt] },
              { icon: 'lightbulb_outline', text: 'Echokontrolle: Verfügbare MYOIDs', routerlink: 'myoidforphysicians', role: [Role.Admin, Role.StudienArzt] },
              { divider: true, role: [Role.Admin, Role.StudienArzt] },
              { heading: 'Admin-Menu', role: [Role.Admin, Role.StudienArzt] },
              { icon: 'archive', text: 'Userliste', routerlink: 'admin_userliste',  role: [Role.Admin, Role.StudienArzt]  },
              { icon: 'file_upload', text: 'File upload', routerlink: 'admin_fileupload', role: [Role.Admin] },
              { icon: 'file_upload', text: 'Statistik', routerlink: 'statistics', role: [Role.Admin, Role.StudienArzt] },
              { divider: true, role: [Role.Observer, Role.Admin, Role.StudienArzt, Role.MFA] },
              { icon: 'lightbulb_outline', text: 'About', routerlink: 'about', role: [Role.Observer, Role.Admin, Role.StudienArzt, Role.MFA] },

      ],
          snack_show: false,
          snack_message: '',
          snack_type: '',

            
        };

    },
    computed: {
        isAdmin () {
            return this.currentUser && this.currentUser.role === Role.Admin;
        }
    },
    created () {
        authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.$transfereHub.$on('HubConnectionStatus', this.onHubConnectionStatus)
        if (this.currentUser) {
          this.loggedin = false;
        }

        this.$store.watch(state => state.snackbartext, () => {
          const msg = this.$store.state.snackbartext
         console.log("snack changed" + this.$store.state.snackbartext)
          if (msg !== '') {
            this.snack_show = true;
            this.snack_message = this.$store.state.snackbartext
            this.snack_type = this.$store.state.snackbartype;
            this.$store.commit('setSnackbar', '','', false)
            
          }
        })

    },
    methods: {
        logout () {
            authenticationService.logout();
            router.push('/login');
        },

        onHubConnectionStatus({ status }) {
            if(status=="ok") {
                this.showSccuessAlert = false;
            } else {
                this.showSccuessAlert = true;
            }
            
        }

 


        
    }
};
</script>


<style lang="stylus">
  #keep
    .v-navigation-drawer__border
      display: none
</style>